export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("OLRToolsUser"));

  if ((user && user.token) || (user && user.access_token)) {
    let token = user.token ? user.token : user.access_token;
    if (!token) return {};
    return "Bearer " + token;
  } else {
    return "";
  }
}
